import z from "zod";

/**
 * ChecklistServicoSchema
 */

export const ChecklistServicoSchema = z.object({
  ativo: z.coerce.boolean().default(false),
  codigo: z.string().nonempty('Este campo deve ser preenchido!'),
  nroRevisao: z.string().nonempty('Este campo deve ser preenchido!'),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
  unidade: z.string().nullable().default(null),
  tipoServico: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  campo1: z.string().default(''),
  campo2: z.string().default(''),
  campo3: z.string().default(''),
  campo4: z.string().default(''),
});

/**
 * ChecklistServicoForm
 */

export type ChecklistServicoForm = z.infer<typeof ChecklistServicoSchema>;

/**
 * initialChecklistServicoForm
 */

export const initialChecklistServicoForm: Partial<ChecklistServicoForm> = {
  ativo: true,
};